import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(2),
  },
  renewalContainer: {
    width: '317.33px',
  },
  subheadingInfoText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '22px',
    color: theme.palette.labraText.description,
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  featureContainer: {
    margin: theme.spacing(5, 0),
  },
  featureText: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
  },
  featureTextContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  borderLine: {
    borderBottom: '1px solid #D1D1D1',
    margin: '20px 0px',
  },
  borderLineOnUpdate: {
    borderBottom: '1px solid #D1D1D1',
    margin: theme.spacing(3, 0),
  },
  updateFeaturesBtn: {
    boxShadow: 'none',
  },
  autoRenewContainer: {
    marginTop: theme.spacing(7),
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  autoRenewDescription: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '22px',
  },
  checkboxContainer: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(-1),
    '& p': {
      fontSize: '16px !important',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px !important',
      letterSpacing: '0.5px',
      color: theme.palette.textField.dark,
      fontFamily: theme.typography.fontFamily,
    },
  },
  featureItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  planSectionRowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  fieldWidth: {
    width: '317.33px !important',
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  formWidth: {
    width: '100%',
    minWidth: '135px',
  },
  saveCancelButton: {
    display: 'flex',
    gap: theme.spacing(2),
  },
}))
